module.exports = __webpack_public_path__ + "static/media/gas_04.fcfbb847.svg";